<template>
  <router-link
    :to="link.path"
    :class="['nav-link', { 'nav-link--active': isActive(link.path) }]"
    :target="link.target"
  >
    <i :class="link.icon"></i>
    <span class="nav-link-text">{{ link.name }}</span>
  </router-link>
</template>
<script>
export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isActive(path) {
      return this.$route.path === path;
      // Si quieres activar también en subrutas: return this.$route.path.startsWith(path);
    },
  },
};
</script>

<style>
.nav-link {
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 16px;
  gap: 8px;
  background-color: #e9ecef;
  backdrop-filter: blur(10px);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  font-weight: 400;
}

.nav-link:hover {
  background-color: #f53d57;
  border: 1px solid #f53d57;
  color: #fff;
}

.nav-link--active {
  background-color: #444446;
  color: #FFF;
}
</style>
